<mat-dialog-content>
  <app-usage-hints (onSkipClick)="closeDialog()"></app-usage-hints>
</mat-dialog-content>
